import { render, staticRenderFns } from "./iFrameWrapper.vue?vue&type=template&id=790afad9&scoped=true&"
import script from "./iFrameWrapper.vue?vue&type=script&lang=js&"
export * from "./iFrameWrapper.vue?vue&type=script&lang=js&"
import style0 from "./iFrameWrapper.vue?vue&type=style&index=0&id=790afad9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790afad9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790afad9')) {
      api.createRecord('790afad9', component.options)
    } else {
      api.reload('790afad9', component.options)
    }
    module.hot.accept("./iFrameWrapper.vue?vue&type=template&id=790afad9&scoped=true&", function () {
      api.rerender('790afad9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/meetings/iFrameWrapper.vue"
export default component.exports